import { createSelector } from '@ngrx/store';

import { getCurrentRoute } from '../getCurrentRoute';

export const routeIsMembershipOnlyPage = (MEMBERSHIP_ONLY_REGEXP: RegExp = /\/membership-only/i) =>
    createSelector(getCurrentRoute, (route) => (route === null ? null : route.url.match(MEMBERSHIP_ONLY_REGEXP) !== null));
